import React, { useState } from "react";
import { useTemplateSetting } from "../hooks/useCompanySettings";
import { TickerArea } from "./TickerArea";
import { TickerOverviewContent } from "./TickerOverviewContent";
import TickerDataLists from "./TickerDataLists/TickerDataLists";
import useInstruments from "../hooks/useInstruments";
import useStockSnapshot from "../real-time/useStockSnapshot";
import useStockTrades from "../real-time/useStockTrades";
import { useDispatch } from "react-redux";
import { updateStockData } from "../actions";

const MainContent = () => {
const template = useTemplateSetting();
const [{ instruments }] = useInstruments();
const [loading, setloading] = useState(true);
const timer = setTimeout(() => {
              if(instruments.length > 0) {
                clearTimeout(timer)
                setloading(false);
              }
            }, 100);
const dispatch = useDispatch();
useStockSnapshot(function(data) {
  dispatch(updateStockData({instrumentId: data.id, data}));
}, instruments.map(item => item.instrumentId));
useStockTrades(function(data) {
  dispatch(updateStockData({instrumentId: data.id, data}));
}, instruments.map(item => item.instrumentId));
  return (
    <>
    {!loading && 
      <div id="print-page" className="print-page">
      <TickerArea />
      {template === 'victor' &&  
        <TickerOverviewContent/>
      }
        <TickerDataLists/>
        </div>
      }
     </>
  );
};

export default MainContent;
